import api from '../utils/api';

const inferenceService = {
  getStatus: (caseId) =>
    api.get(`/inference/${caseId}/status/`).then(r => r.data),

  getResult: (caseId) =>
    api.get(`/inference/${caseId}/result/`).then(r => r.data),

  runAnalysis: (caseId) =>
    api.post(`/inference/${caseId}/run/`).then(r => r.data),
};

export default inferenceService;
